import React from "react";
import "../../Styles/yellowcalf.css/Wallet_Recharges.css";
import { FaSearch } from "react-icons/fa";

function Wallet_Recharges() {
  return (
    <div className="recharge-container" style={{ paddingTop: "25px" }}>
      
      {/* Action Panel */}
      <div className="recharge-panel recharge-main-page-header" style={{ height: '60px' }}>
        <div className="recharge-panel-body">
          <div className="recharge-header">
            <h3 className="recharge-title">Wallet Recharges</h3>

            <div className="recharge-btn-group d-flex">
              <a
                style={{ height: '40px', marginTop: '-5px' }}
                className="recharge-btn recharge-btn-green"
                href="/accountant/New_Recharge"
              >
                New Recharge
              </a>

              <div className="recharge-dropdown">
                <button
                  style={{ marginTop: '-3px', height: '40px', borderColor: '#6dd4f0ff' }}
                  className="recharge-btn recharge-btn-warning dropdown-toggle"
                  data-bs-toggle="dropdown"
                >
                  Export <i className="fa fa-angle-down"></i>
                </button>

                <ul className="recharge-dropdown-menu dropdown-menu dropdown-menu-end">
                  <li><a href="#" className="recharge-export">Save as PDF</a></li>
                  <li><a href="#" className="recharge-export">Save as PNG</a></li>
                  <li><a href="#" className="recharge-export">Save as CSV</a></li>
                  <li><a href="#" className="recharge-export">Save as TXT</a></li>
                  <li><a href="#" className="recharge-export">Save as XML</a></li>
                  <li><a href="#" className="recharge-export">Save as SQL</a></li>
                  <li><a href="#" className="recharge-export">Save as JSON</a></li>
                  <li><a href="#" className="recharge-export">Export to Excel</a></li>
                  <li><a href="#" className="recharge-export">Export to Word</a></li>
                  <li><a href="#" className="recharge-export">Export to PowerPoint</a></li>
                </ul>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="recharge-panel">
        <div className="recharge-panel-body">
          <div className="d-flex gap-3" style={{ maxWidth: "600px" }}>
            <div style={{ position: "relative", flex: 1 }}>
              <FaSearch
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#888",
                  fontSize: "14px",
                }}
              />
              <input
                type="text"
                className="form-control"
                placeholder="Student Name"
                style={{ paddingLeft: "30px", textAlign: "left" }}
              />
            </div>

            <div style={{ position: "relative", flex: 1 }}>
              <FaSearch
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#888",
                  fontSize: "14px",
                }}
              />
              <input
                type="text"
                className="form-control"
                placeholder="Date/Time"
                style={{ paddingLeft: "30px", textAlign: "left" }}
              />
            </div>

            <div style={{ position: "relative", flex: 1 }}>
              <FaSearch
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#888",
                  fontSize: "14px",
                }}
              />
              <input
                type="text"
                className="form-control"
                placeholder="Recharge ID"
                style={{ paddingLeft: "30px", textAlign: "left" }}
              />
            </div>

          </div>
        </div>
      </div>

      {/* Table */}
      <div className="recharge-panel">
        <div className="recharge-panel-body">
          <div className="recharge-table-responsive">
            <table className="recharge-table table table-hover">
              <thead style={{ height: '62px' }}>
                <tr>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Sr.NO</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Student</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Amount</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Date Time</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Recharge ID</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Reference No</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Recharge Mode</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Operator</th>
                  <th style={{ textAlign: "center", verticalAlign: "middle" }}>Status</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>

              <tbody style={{ fontSize: '10px' }}>
                <tr>
                  <td align="center">1</td><td align="center">John Doe</td><td align="center">₹500</td>
                  <td align="center">2025-09-24 10:00</td><td align="center">RCG1001</td>
                  <td align="center">REF9001</td><td align="center">Online</td>
                  <td align="center">Paytm</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">2</td><td align="center">Alex Smith</td><td align="center">₹300</td>
                  <td align="center">2025-09-24 10:15</td><td align="center">RCG1002</td>
                  <td align="center">REF9002</td><td align="center">Online</td>
                  <td align="center">GPay</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">3</td><td align="center">Rahul Patil</td><td align="center">₹700</td>
                  <td align="center">2025-09-24 10:30</td><td align="center">RCG1003</td>
                  <td align="center">REF9003</td><td align="center">Cash</td>
                  <td align="center">Admin</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">4</td><td align="center">Sneha Kale</td><td align="center">₹450</td>
                  <td align="center">2025-09-24 10:45</td><td align="center">RCG1004</td>
                  <td align="center">REF9004</td><td align="center">Online</td>
                  <td align="center">PhonePe</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">5</td><td align="center">Amit Shah</td><td align="center">₹1000</td>
                  <td align="center">2025-09-24 11:00</td><td align="center">RCG1005</td>
                  <td align="center">REF9005</td><td align="center">Online</td>
                  <td align="center">Paytm</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">6</td><td align="center">Neha Verma</td><td align="center">₹250</td>
                  <td align="center">2025-09-24 11:15</td><td align="center">RCG1006</td>
                  <td align="center">REF9006</td><td align="center">Cash</td>
                  <td align="center">Admin</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">7</td><td align="center">Rohit Sharma</td><td align="center">₹600</td>
                  <td align="center">2025-09-24 11:30</td><td align="center">RCG1007</td>
                  <td align="center">REF9007</td><td align="center">Online</td>
                  <td align="center">GPay</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">8</td><td align="center">Pooja More</td><td align="center">₹350</td>
                  <td align="center">2025-09-24 11:45</td><td align="center">RCG1008</td>
                  <td align="center">REF9008</td><td align="center">Online</td>
                  <td align="center">PhonePe</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">9</td><td align="center">Karan Joshi</td><td align="center">₹800</td>
                  <td align="center">2025-09-24 12:00</td><td align="center">RCG1009</td>
                  <td align="center">REF9009</td><td align="center">Online</td>
                  <td align="center">Paytm</td><td align="center">Success</td><td></td>
                </tr>
                <tr>
                  <td align="center">10</td><td align="center">Anita Desai</td><td align="center">₹550</td>
                  <td align="center">2025-09-24 12:15</td><td align="center">RCG1010</td>
                  <td align="center">REF9010</td><td align="center">Cash</td>
                  <td align="center">Admin</td><td align="center">Success</td><td></td>
                </tr>
              </tbody>
            </table>
 <div style={{ padding: '20px', marginTop:'-40px' }}>
      <div
        style={{
          flex: '1',
          display: 'flex',
          justifyContent: 'space-between',
          marginTop: '8px',
        }}
      >
     
        <div style={{ color: '#333', fontSize: '14px' }}>
          Showing 1 to 10 of 177 entries
        </div>

        <ul
          style={{
            display: 'flex',
            listStyle: 'none',
            gap: '6px',
            margin: 0,
            padding: 0,
          }}
        >
          {['1', '2', '3'].map((num) => (
            <li key={num}>
              <a
                href="#"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '28px',
                  height: '28px',
                  border: '1px solid #6dd4f0',
                  backgroundColor: num === '1' ? '#4fa3e8' : '#edf5f7ff', 
                  color: '#171717ff',
                  borderRadius: '4px',
                  fontSize: '12px',
                  textDecoration: 'none',
                }}
              >
                {num}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
    </div>
        </div>
      </div>
    </div>
  );
}

export default Wallet_Recharges;
